// https://app.growthbook.io/features/mccerts-2548_v1
export const MCCERTS_2548_SUBSCRIPTIONS_ENTRY_POINT_FLAG = 'mccerts-2548_v1'

export type SubscriptionsEntryPointBucket =
  | 'control'
  | 'variant_1'
  | 'variant_2'
  | 'variant_3'
